// eslint-disable-next-line import/prefer-default-export
export const logTestResult = 'LOG_TEST_RESULT';
export const resetTestResults = 'RESET_TEST_RESULTS';
